import { PrimaryButton, Reveal } from "@/components/ui-bits";
import { ServiceTag, CapList, ImageFrame } from "@/pages/services/bits";

const EQUIPMENT = ["SPRINTER VAN", "STRAIGHT TRUCK WITH TAILGATE", "DRY VAN"];

const CAPABILITIES = [
  "TIME-CRITICAL SHIPMENTS",
  "DIRECT TRANSPORTATION",
  "SAME-DAY DELIVERY OPTIONS",
  "EXPEDITED COMMERCIAL FREIGHT",
  "HOT SHOT TRANSPORTATION",
];

const ServiceExpedite = () => {
  return (
    <section id="expedite" data-testid="service-expedite" aria-labelledby="expedite-heading" className="scroll-mt-24 bg-white py-16 sm:py-20 lg:py-24">
      <div className="container-30 grid items-stretch gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal className="order-2">
          <ServiceTag number="03" label="Time-Critical" />
          <h2 id="expedite-heading" data-testid="expedite-headline" className="mt-6 font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-[#191c1e] sm:text-4xl">
            EXPEDITED & HOT SHOT
          </h2>
          <p className="mt-3 font-display text-lg font-semibold text-[#191c1e]/80">
            When timing matters, move without unnecessary stops.
          </p>
          <p className="mt-5 text-base leading-relaxed text-[#5f666d]">
            For time-sensitive shipments, 30 NORTH provides expedited transportation options designed to move freight
            quickly and directly to its destination.
          </p>
          <div className="mt-8 flex flex-wrap gap-2" data-testid="expedite-equipment">
            {EQUIPMENT.map((label) => (
              <span
                key={label}
                className="border border-[#191c1e]/20 px-4 py-2 text-[11px] font-bold tracking-[0.14em] text-[#191c1e]"
              >
                {label}
              </span>
            ))}
          </div>
          <div className="mt-8">
            <CapList items={CAPABILITIES} testid="expedite-capabilities" />
          </div>
          <div className="mt-10">
            <PrimaryButton to="/request-a-quote" testid="expedite-cta">
              REQUEST EXPEDITED SERVICE
            </PrimaryButton>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="order-1">
          <ImageFrame
            src="/assets/sprinter-van.webp"
            alt="A white 30 NORTH Sprinter van at an Ontario business park providing expedited delivery"
            testid="expedite-image"
            className="aspect-[4/3] lg:aspect-auto lg:h-full lg:min-h-[420px]"
            caption={<>SPRINTER VAN <span className="ml-2 text-[#ff6a00]">EXPEDITE & TIME-CRITICAL</span></>}
          />
        </Reveal>
      </div>
    </section>
  );
};

export default ServiceExpedite;
